<div class="content-wrapper">
  <div class="row">
    <div class="col-lg-12 grid-margin stretch-card">
      <div class="card">
        <div class="card-body">
          <h4 class="card-title">Employee Uploads</h4>
          <div class="table-responsive pt-3">

            <div class="send-request">
              <button nz-button nzType="primary" [disabled]="setOfCheckedId.size === 0" [nzLoading]="loading"
                (click)="sendRequest()">
                Submit Selected Records
              </button>
            </div>

            <div class="send-request" style="float: right;">
              <a nz-popconfirm nzPopconfirmTitle="Are you sure?" nzOkText="ok" nzCancelText="cancel"
                (nzOnConfirm)="functionToDeleteItem()" (nzOnCancel)="cancel()">
                <span style="margin-right: 8px;" class="btn btn-primary">
                  Delete
                </span>
              </a>
            </div>

            <span>Selected : {{ setOfCheckedId.size }} items</span>
            <br />
            <span>Active Number of Eployees : {{ NumberofActiveEmployees }} </span>
          
         <div>
          
<hr/>

          <div class="row">

            <div class="col">
              <div class="form-group">
                <label><b>Medical Requirement</b></label>
                <textarea class="form-control" id="medicalNotes" rows="1" name="medicalNotes" [(ngModel)]="medicalNotes"
                  required> </textarea>
              </div>
            </div>
<!-- 
            <div class="col">
              <div class="form-group">
                <label><b>Safety Requirement</b></label>
                <textarea class="form-control" id="safetyInductionNotes" rows="1" name="safetyInductionNotes"
                  [(ngModel)]="safetyInductionNotes" required> </textarea>
              </div>
            </div>
          -->
          </div>
         </div>
             
          
            <nz-table #uploadedEmpsTable nzShowPagination nzShowSizeChanger [nzData]="Employees"
              (nzCurrentPageDataChange)="onCurrentPageDataChange($event)" [nzScroll]="{ x: '1650px' }">
              <thead>
                <tr>
                  <!-- <th nzLeft [nzChecked]="checked" [nzIndeterminate]="indeterminate" (nzCheckedChange)="onAllChecked($event)"></th> -->
                  <th nzLeft style="width: 5%;">S/N</th>
                  <th nzLeft>Name</th>
                  <th>Gender</th>
                  <th>Medical</th>
                  <th>Biometric</th>
                  <th>Start Date</th>
                  <th>End Date</th>
                  <th>Mode Of Head count</th>
                  <th>Head Count Classification</th>
                  <!-- <th>Position</th> -->
                  <th>Details</th>
                  <th nzRight>Mark All</th>

                </tr>

                <!-- Selection row -->
                <tr>
                  <th nzLeft></th>
                  <th nzLeft></th>
                  <th> </th>
                  <th [nzChecked]="checkedMedical" (nzCheckedChange)="onAllCheckedMedical($event)"></th>
                  <th [nzChecked]="checkedBiometric" (nzCheckedChange)="onAllCheckedBiometric($event)"></th>
                  <th>
                    <!-- <nz-date-picker [(ngModel)]="defaultStartDate" (ngModelChange)="onChangeStartDate($event)">
                    </nz-date-picker> -->
                  </th>
                  <th>
                    <!-- <nz-date-picker [(ngModel)]="defaultEndDate" (ngModelChange)="onChangeEndDate($event)">
                    </nz-date-picker> -->
                  </th>
                  <th>
                    <!-- <select style="padding: 4px; border-color: #ece7e7;" (change)="onChangeSkill($event)">
                      <option value="">Select Skill</option>
                      <option *ngFor="let skill of Skills" [value]="skill.id">{{skill.name}}</option>
                    </select> -->
                  </th> 

                  <th>
                    <!-- <select style="padding: 4px; border-color: #ece7e7;" (change)="onChangeCategory($event)">
                      <option *ngFor="let eClass of contractorType | keyvalue" [value]="eClass.key">{{eClass.value}}
                      </option>
                    </select> -->
                  </th> 

                  <th></th>

                  <th nzRight [nzChecked]="checked" [nzIndeterminate]="indeterminate"
                    (nzCheckedChange)="onAllChecked($event)"></th>
                </tr>
                <!-- Selection row end -->
              </thead>
              <tbody>
                <tr *ngFor="let data of uploadedEmpsTable.data; let i = index">

                  <!-- <td nzLeft [nzChecked]="setOfCheckedId.has(data.id)" (nzCheckedChange)="onItemChecked(data, $event)"></td> -->

                  <td nzLeft>{{i + 1}}</td>
                  <td nzLeft> {{data.firstName}} {{data.lastName}}</td>
                  <td> {{data.gender}}</td>
                  <td>
                    <label class="custom-control custom-checkbox">
                      <input type="checkbox" value="isMedical" [checked]="data.isMedicalRequired"
                        [(ngModel)]="data.isMedicalRequired" />
                    </label>
                  </td>

                  <td>
                    <label class="custom-control custom-checkbox">
                      <input type="checkbox" value="isBiometric" [checked]="data.isBiometricRequired"
                        [(ngModel)]="data.isBiometricRequired" />
                    </label>
                  </td>

                  <td>
                    <!-- <nz-date-picker [(ngModel)]="data.startDate"></nz-date-picker> -->
                     {{data.startDate  | date: 'MMMM dd, yyy.'}}
                  </td>

                  <td>
                    <!-- <nz-date-picker [(ngModel)]="data.endDate"></nz-date-picker> -->
                     {{data.endDate | date: 'MMMM dd, yyy.'}}
                  </td>

                  <td>
                    <!-- <select style="padding: 4px; border-color: #ece7e7;" [(ngModel)]="data.skillId">
                      <option value="">Select Skill</option>
                      <option *ngFor="let skill of Skills" [value]="skill.id">{{skill.name}}</option>
                    </select> -->
                     {{data.modeOfHeadCount}}
                  </td>

                  <!-- <td>
  <select 
    style="padding: 4px; border-color: #ece7e7;" 
    required 
    [(ngModel)]="data.employeeClass"
  >
    <option value="" disabled selected *ngIf="!data.employeeClass">{{data.modeOfHeadCount}}</option>
    <option 
      *ngFor="let eClass of contractorType | keyvalue" 
      [value]="eClass.key"
    >
      {{ eClass.value }}
    </option>
  </select>
</td> -->
<td> {{data.headCountClassification}}</td>
                  <!-- <td> {{data.position}}</td> -->
                  <!-- <td></td> -->
                  <td><span class="clickable btn btn-primary" (click)="open(data)">View details</span></td>

                  <td nzRight [nzChecked]="setOfCheckedId.has(data.id)" (nzCheckedChange)="onItemChecked(data, $event)">
                  </td>

                </tr>
              </tbody>
            </nz-table>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>


<!-- Drawer -->
<nz-drawer [nzBodyStyle]="{ overflow: 'auto' }" [nzMaskClosable]="false" [nzWidth]="720"
  [nzVisible]="ViewEmployeeVisible" nzTitle="" [nzFooter]="footerTpl" (nzOnClose)="close()">

  <!-- Side swipe content -->
  <div class="row">
    <div class="col-lg-12 grid-margin stretch-card">
      <div class="card">
        <h5 class="card-title">Employee Details</h5>
        <div class="card-body">
          <div class="row">

            <div class="col">
              <label><b>Name</b></label>
              <p>{{ EmployeeData?.firstName }} {{ EmployeeData?.lastName }}</p>
            </div>

            <div class="col">
              <label><b>Email</b></label>
              <p>{{ EmployeeData?.email }}</p>
            </div>
          </div>

          <div class="row">

            <div class="col">
              <label><b>Phone number</b></label>
              <p>{{ EmployeeData?.phoneNumber }}</p>
            </div>

            <div class="col">
              <label><b>Gender</b></label>
              <p>{{ EmployeeData?.gender }}</p>
            </div>

          </div>

          <div class="row">

            <div class="col">
              <label><b>Date Of Birth</b></label>
              <p>{{ EmployeeData?.dateOfBirth | date: 'dd MMMM yyyy'  }}</p>
            </div>

            <div class="col">
              <label><b>Address</b></label>
              <p>{{ EmployeeData?.address }}</p>
            </div>

          </div>

          <div class="row">

            <div class="col">
              <label><b>Qualification</b></label>
              <p>{{ EmployeeData?.qualification }}</p>
            </div>

            <div class="col">
              <label><b>Position</b></label>
              <p>{{ EmployeeData?.position }}</p>
            </div>

          </div>

          <div class="row">

            <div class="col">
              <label><b>Previous Employer</b></label>
              <p>{{ EmployeeData?.lastPlaceOfWork }}</p>
            </div>

            <div class="col">
              <label><b>Next of Kin</b></label>
              <p>{{ EmployeeData?.nextOfKin }}</p>
            </div>

          </div>

          <div class="row">

            <div class="col">
              <label><b>Next of Kin's Phone</b></label>
              <p>{{ EmployeeData?.nextOfKinPhone }}</p>
            </div>

            <div class="col">
              <label><b>Next of Kin's Address</b></label>
              <p>{{ EmployeeData?.nextOfKinAddress }}</p>
            </div>

          </div>
        </div>

        <hr>

        
        <div class="card-body">

          <div class="row">

            <!-- <div class="col">
              <label><b>Contract Reference</b></label>
              <p>{{ EmployeeData?.contractReference }}</p>
            </div> -->

            <!-- <div class="col">
              <label><b>Function</b></label>
              <p>{{ EmployeeData?.departmentName }}</p>
            </div> -->
          </div>

          <!-- <div class="row"> -->

            <!-- <div class="col">
              <label><b>Location</b></label>
              <p>{{ EmployeeData?.locationName }}</p>
            </div> -->

            <!-- <div class="col">
              <label><b>Cost Center</b></label>
              <p>{{ EmployeeData?.costCenterName }}</p>
            </div> -->
          <!-- </div> -->

          <div class="row">

            <!-- <div class="col">
              <label><b>Contractor</b></label>
              <p>{{ EmployeeData?.contractorName }}</p>
            </div> -->

            <div class="col">
              <label><b>Start Date</b></label>
              <p>{{ EmployeeData?.startDate | date: 'dd MMMM yyyy' }}</p>
            </div>

          </div>

          <div class="row">

            <div class="col">
              <label><b>Expected End Date</b></label>
              <p>{{ EmployeeData?.endDate | date: 'dd MMMM yyyy' }}</p>
            </div>

            <!-- <div class="col">
              <label><b> Class</b></label>
              <p>{{ EmployeeData?.employeeClass }}</p>
            </div> -->

          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Side swipe content -->

  <ng-template #footerTpl>
    <button class="btn btn-light" style="margin-right: 8px;" style="margin-right: 8px;"
      (click)="close()">Close</button>
  </ng-template>

</nz-drawer>
<!-- Drawer -->